import { TATTOO_SEARCH_ENDPOINT } from '@/config/endpoints'

export interface VectorSearchRequest {
  imageUrl?: string
  query?: string
  city: string
  collections: ('flashes' | 'portfolioItems' | 'healedPortfolioItems')[]
}

export interface VectorSearchResult {
  id: string
  score: number
  type: 'flash' | 'portfolioItem' | 'healedPortfolioItem'
}

export interface VectorSearchResponse {
  results: VectorSearchResult[]
}

/**
 * Perform vector search for tattoos using image and/or text query
 */
export async function performVectorSearch({
  imageUrl,
  query,
  city,
  collections
}: VectorSearchRequest): Promise<VectorSearchResult[]> {
  // Validate that at least one of imageUrl or query is provided
  if (!imageUrl && !query) {
    throw new Error('At least one of imageUrl or query must be provided')
  }

  if (city == null) {
    throw new Error('City is required for vector search')
  }

  if (!collections || collections.length === 0) {
    throw new Error('At least one collection must be specified')
  }

  try {
    const requestBody: VectorSearchRequest = {
      city,
      collections
    }

    if (imageUrl) {
      requestBody.imageUrl = imageUrl
    }

    if (query) {
      requestBody.query = query
    }

    console.log('[vectorSearch] Making request:', requestBody)

    const response = await fetch(TATTOO_SEARCH_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    })

    if (!response.ok) {
      const errorText = await response.text()
      console.error('[vectorSearch] Request failed:', {
        status: response.status,
        statusText: response.statusText,
        error: errorText
      })
      throw new Error(`Vector search failed: ${response.status} ${response.statusText}`)
    }

    const data: VectorSearchResponse = await response.json()
    console.log('[vectorSearch] Response received:', {
      resultsCount: data.results?.length || 0,
      results: data.results?.slice(0, 5) // Log first 5 results for debugging
    })

    return data.results || []

  } catch (error) {
    console.error('[vectorSearch] Error performing vector search:', error)
    throw error
  }
}
